module.exports = __webpack_public_path__ + "static/assets/acc736bbb7d27352419a9d98a5e7eb24.png";